// Améliorations pour le cart drawer

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart drawer enhancement loaded');
  
  // Améliorer la classe CartDrawer
  class EnhancedCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.isProcessing = false; // Flag pour éviter les traitements multiples
      this.bindEvents();
    }

    bindEvents() {
      // Fermer le cart drawer en cliquant sur l'overlay
      this.addEventListener('click', (event) => {
        if (event.target === this || event.target.classList.contains('cart-drawer__overlay')) {
          this.close();
        }
      });

      // Fermer avec la touche Escape
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('active')) {
          this.close();
        }
      });

      // Gérer les changements de quantité
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[data-quantity-variant-id]')) {
          this.updateQuantity(event.target);
        }
      });

      // Gérer les suppressions d'articles
      this.addEventListener('click', (event) => {
        const removeButton = event.target.closest('cart-remove-button') || 
                           event.target.closest('.cart-drawer-item__cart-remove-button') ||
                           event.target.closest('[data-index]') ||
                           event.target.closest('[data-variant-id]');
        
        if (removeButton && (removeButton.dataset.index || removeButton.dataset.variantId)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          // Vérifier si le bouton n'est pas déjà en cours de traitement
          if (!removeButton.disabled && !removeButton.classList.contains('loading')) {
            console.log('Bouton de suppression cliqué:', {
              index: removeButton.dataset.index,
              variantId: removeButton.dataset.variantId,
              element: removeButton
            });
            this.removeItem(removeButton);
          }
        }
      });
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      
      // Focus sur le premier élément focusable
      const focusableElement = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableElement) {
        focusableElement.focus();
      }
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      
      // Retourner le focus à l'élément qui avait le focus avant l'ouverture
      if (this.previousActiveElement) {
        this.previousActiveElement.focus();
      }
    }

    updateQuantity(input) {
      const variantId = input.dataset.quantityVariantId;
      const quantity = parseInt(input.value);
      const index = input.dataset.index;

      if (quantity < 1) {
        input.value = 1;
        return;
      }

      // Ajouter une classe de chargement
      input.closest('.cart-drawer-item').classList.add('loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(cart => {
        this.updateCartDrawer();
      })
      .catch(error => {
        console.error('Error updating quantity:', error);
        // Remettre l'ancienne valeur en cas d'erreur
        input.value = input.defaultValue;
      })
      .finally(() => {
        input.closest('.cart-drawer-item').classList.remove('loading');
      });
    }

    removeItem(button) {
      // Empêcher les clics multiples et les traitements simultanés
      if (button.disabled || button.classList.contains('loading') || this.isProcessing) {
        console.log('Suppression déjà en cours ou bouton désactivé');
        return;
      }
      
      const index = button.dataset.index;
      const variantId = button.dataset.variantId;
      const item = button.closest('.cart-drawer-item');
      
      if ((!index && !variantId) || !item) {
        console.error('Index, variant ID ou item non trouvé pour la suppression');
        return;
      }
      
      // Si pas d'index mais un variant ID, utiliser directement l'ID de variante
      if (!index && variantId) {
        console.log('Utilisation de l\'ID de variante (pas d\'index disponible):', variantId);
        this.removeItemByVariantId(variantId, button, item);
        return;
      }
      
      // Convertir l'index en nombre et valider
      const lineIndex = parseInt(index, 10);
      if (isNaN(lineIndex) || lineIndex < 1) {
        console.error('Index de ligne invalide:', index);
        // Essayer avec l'ID de variante comme fallback
        if (variantId) {
          console.log('Utilisation de l\'ID de variante comme fallback:', variantId);
          this.removeItemByVariantId(variantId, button, item);
          return;
        }
        return;
      }
      
      // Marquer comme en cours de traitement
      this.isProcessing = true;
      
      // Désactiver le bouton et ajouter une classe de chargement
      button.disabled = true;
      button.classList.add('loading');
      item.classList.add('loading');

      console.log('Suppression de l\'item avec index:', lineIndex);

      // Utiliser l'index pour supprimer l'élément
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: 0
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        console.log('Item supprimé avec succès:', cart);
        this.updateCartDrawer();
      })
      .catch(error => {
        console.error('Error removing item:', error);
        // Réactiver le bouton en cas d'erreur
        button.disabled = false;
        button.classList.remove('loading');
        item.classList.remove('loading');
      })
      .finally(() => {
        // Réactiver le traitement après un délai
        setTimeout(() => {
          this.isProcessing = false;
        }, 500);
      });
    }

    removeItemByVariantId(variantId, button, item) {
      // Marquer comme en cours de traitement
      this.isProcessing = true;
      
      // Désactiver le bouton et ajouter une classe de chargement
      button.disabled = true;
      button.classList.add('loading');
      item.classList.add('loading');

      console.log('Suppression de l\'item avec variant ID:', variantId);

      // Utiliser l'ID de variante pour supprimer l'élément
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        console.log('Item supprimé avec succès (variant ID):', cart);
        this.updateCartDrawer();
      })
      .catch(error => {
        console.error('Error removing item (variant ID):', error);
        // Réactiver le bouton en cas d'erreur
        button.disabled = false;
        button.classList.remove('loading');
        item.classList.remove('loading');
      })
      .finally(() => {
        // Réactiver le traitement après un délai
        setTimeout(() => {
          this.isProcessing = false;
        }, 500);
      });
    }

    updateCartDrawer() {
      fetch('/?sections=cart-drawer&sections_url=' + encodeURIComponent(window.location.pathname))
        .then(response => response.json())
        .then(sections => {
          if (sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const newCartDrawer = doc.querySelector('cart-drawer');
            if (newCartDrawer) {
              // Préserver l'état actif
              const wasActive = this.classList.contains('active');
              
              // Mettre à jour le contenu
              this.innerHTML = newCartDrawer.innerHTML;
              
              // Réattacher les event listeners
              this.rebindEvents();
              
              if (wasActive) {
                this.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
              
              console.log('Cart drawer mis à jour avec succès');
            }
          }
        })
        .catch(error => {
          console.error('Error updating cart drawer:', error);
        });
    }
    
    rebindEvents() {
      // Réattacher les event listeners après la mise à jour du DOM
      console.log('Réattachement des event listeners...');
      
      // Réattacher les boutons de suppression
      const removeButtons = this.querySelectorAll('cart-remove-button, .cart-drawer-item__cart-remove-button, [data-index]');
      removeButtons.forEach(button => {
        // Supprimer les anciens event listeners
        button.removeEventListener('click', this.handleRemoveClick);
        
        // Ajouter le nouvel event listener
        button.addEventListener('click', this.handleRemoveClick.bind(this));
      });
      
      // Réattacher les boutons de quantité
      const quantityButtons = this.querySelectorAll('.quantity__button');
      quantityButtons.forEach(button => {
        button.removeEventListener('click', this.handleQuantityClick);
        button.addEventListener('click', this.handleQuantityClick.bind(this));
      });
    }
    
    handleRemoveClick(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      const button = event.currentTarget;
      if (!button.disabled && !button.classList.contains('loading')) {
        this.removeItem(button);
      }
    }
    
    handleQuantityClick(event) {
      const button = event.currentTarget;
      const input = button.parentNode.querySelector('.quantity__input');
      if (input) {
        const currentValue = parseInt(input.value) || 0;
        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 999;
        const step = parseInt(input.step) || 1;
        
        if (button.name === 'plus') {
          input.value = Math.min(currentValue + step, max);
        } else if (button.name === 'minus') {
          input.value = Math.max(currentValue - step, min);
        }
        
        // Déclencher l'événement change
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // Enregistrer le composant personnalisé si il n'existe pas déjà
  if (!customElements.get('enhanced-cart-drawer')) {
    customElements.define('enhanced-cart-drawer', EnhancedCartDrawer);
  }

  // Définir le composant cart-remove-button s'il n'existe pas
  if (!customElements.get('cart-remove-button')) {
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      handleClick(event) {
        // Empêcher les clics multiples
        if (this.disabled || this.classList.contains('loading')) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        const index = this.dataset.index;
        if (index) {
          console.log('CartRemoveButton: Suppression demandée pour index:', index);
          
          // Déclencher l'événement de suppression
          const removeEvent = new CustomEvent('cart:remove', {
            detail: { index: index },
            bubbles: true,
            cancelable: true
          });
          
          const dispatched = this.dispatchEvent(removeEvent);
          if (!dispatched) {
            console.log('Événement cart:remove annulé');
          }
        }
      }
      
      disconnectedCallback() {
        // Nettoyer les event listeners
        this.removeEventListener('click', this.handleClick);
      }
    }
    customElements.define('cart-remove-button', CartRemoveButton);
  }

  // Améliorer les boutons de quantité
  function enhanceQuantityButtons() {
    const quantityButtons = document.querySelectorAll('.quantity__button');
    
    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        const input = this.parentNode.querySelector('.quantity__input');
        const currentValue = parseInt(input.value) || 0;
        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 999;
        const step = parseInt(input.step) || 1;
        
        if (this.name === 'plus') {
          input.value = Math.min(currentValue + step, max);
        } else if (this.name === 'minus') {
          input.value = Math.max(currentValue - step, min);
        }
        
        // Déclencher l'événement change
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // Améliorer les boutons de fermeture
  function enhanceCloseButtons() {
    const closeButtons = document.querySelectorAll('.drawer__close');
    
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const cartDrawer = this.closest('cart-drawer');
        if (cartDrawer) {
          cartDrawer.close();
        }
      });
    });
  }

  // Initialiser les améliorations
  function initEnhancements() {
    enhanceQuantityButtons();
    enhanceCloseButtons();
  }

  // Initialiser au chargement
  initEnhancements();

  // Réinitialiser après les mises à jour de sections Shopify
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('cart-drawer')) {
        setTimeout(initEnhancements, 100);
      }
    });
  }

  // Observer les changements dans le DOM pour réinitialiser les améliorations
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches('cart-drawer') || node.querySelector('cart-drawer'))) {
            // Délai plus long pour éviter les conflits
            setTimeout(initEnhancements, 300);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Écouter les événements de suppression pour éviter les conflits
  document.addEventListener('cart:remove', function(event) {
    console.log('Événement cart:remove reçu:', event.detail);
    // Empêcher la propagation si déjà traité
    if (event.detail && event.detail.processed) {
      event.stopPropagation();
    }
  }, true);
}); 